import { SearchObject } from "app/common/Model/SearchObject";
import { searchDrugOrderReport } from "app/services/DrugService";
import { exportReportDrugItem } from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReportRegisterDrugStore {
  listDataReportDrug = null;

  searchReportDrug = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    fromVoucherDate: null,
    toVoucherDate: null,
    listDepId: null,
    drugCode: null,
    drugName: null,
    drugId: null,
    drugGroupId: null,
    phoneNumber: null,
    patientName: null,
    patientCode: null,
  };

  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchReportDrug = (searchReportDrug) => {
    this.searchReportDrug = {
      ...this.searchReportDrug,
      ...searchReportDrug,
    };
    this.pagingReportDrug();
  };

  pagingReportDrug = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchReportDrug.listDepId || this.searchReportDrug.listDepId.length === 0) {
      this.listDataReportDrug = null;
      return;
    }
    
    const search = {
      ...this.normalizeSearchReportDrug(this.searchReportDrug),
      getPatient: true,
    };

    return await searchDrugOrderReport(search)
      .then(({ data }) => {
        this.listDataReportDrug = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu sản phẩm có lỗi");
      });
  };

  handleExportRegisterDrug = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = {
      ...this.normalizeSearchReportDrug(searchObj),
      getPatient: true,
    };
    try {
      const response = await exportReportDrugItem(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_DANG_KI_SAN_PHAM.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportDrug = (rawSearch = {}) => {
    const {
      listDepId,
      drugCode,
      drugName,
      drugId,
      drugGroupId,
      phoneNumber,
      patientName,
      patientCode,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      listDepId: listDepId?.map((el) => el?.id) || null,
      drugCode: drugCode || null,
      drugName: drugName || null,
      drugId: drugId?.id || null,
      drugGroupId: drugGroupId?.id || null,
      phoneNumber: phoneNumber || null,
      patientName: patientName || null,
      patientCode: patientCode || null,
    };
  };

  resetStore = () => {
    this.listDataReportDrug = null;
    this.searchReportDrug = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      listDepId: null,
      drugCode: null,
      drugName: null,
      drugId: null,
      drugGroupId: null,
      phoneNumber: null,
      patientName: null,
      patientCode: null,
    };
  };
}
